"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import BaseTwinControl from "D5Utils/form_fields/BaseTwinControl";
import { System } from "Constants/objects";
import { getDatePlaceholder } from "D5Utils/functions";

var DateTwinControl =
/*#__PURE__*/
function (_BaseTwinControl) {
  _inherits(DateTwinControl, _BaseTwinControl);

  function DateTwinControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DateTwinControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateTwinControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_type", System.DX_CONTROLS.dxDateBox);

    return _this;
  }

  _createClass(DateTwinControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps(data) {
      var _this2 = this;

      return _objectSpread({}, _get(_getPrototypeOf(DateTwinControl.prototype), "_buildControlProps", this).call(this, data), {
        type: this.props.dType,
        placeholder: getDatePlaceholder(this.props.dType),
        showClearButton: true,
        useMaskBehavior: true,
        width: '100%',
        onValueChanged: function onValueChanged(e) {
          _this2.$fieldFrom.attr('data-from', e.value);

          var from = e.value != null ? new Date(e.value) : undefined;
          var to = e.element.attr('data-to') != null ? new Date(e.element.attr('data-to')) : undefined;
          _this2.value = from == null && null == to ? [] : [from, to];

          _this2.riseValueChange();
        }
      });
    }
  }, {
    key: "_buildControlToProps",
    value: function _buildControlToProps() {
      var _this3 = this;

      return _objectSpread({
        type: this.props.dType,
        width: '100%',
        placeholder: getDatePlaceholder(this.props.dType),
        showClearButton: true,
        useMaskBehavior: true
      }, _get(_getPrototypeOf(DateTwinControl.prototype), "_buildControlToProps", this).call(this), {
        onValueChanged: function onValueChanged(e) {
          _this3.$fieldFrom.attr('data-to', e.value);

          var from = _this3.$fieldFrom.attr('data-from') != null ? new Date(_this3.$fieldFrom.attr('data-from')) : undefined;
          var to = e.value != null ? new Date(e.value) : undefined;
          _this3.value = from == null && null == to ? [] : [from, to];

          _this3.riseValueChange();
        }
      });
    }
  }, {
    key: "riseValueChange",
    value: function riseValueChange() {
      if (Array.isArray(this.value) && (this.value[0] != null && this.value[1] != null || this.value[0] == null && this.value[1] == null) && typeof this.props.onValueChanged === 'function') {
        this.props.onValueChanged({
          value: this.value
        });
      }
    }
  }, {
    key: "_comparisonTarget",
    value: function _comparisonTarget(options) {
      // let instance = this.$fieldFrom[this._type]("instance");
      // if (instance) {
      //     let value = instance.option("value");
      //     return (value == null && options.value == null) || new Date(value) <= new Date(options.value);
      // }
      return true;
    }
  }]);

  return DateTwinControl;
}(BaseTwinControl);

export { DateTwinControl as default };